

















import { User } from 'oidc-client';
import { UsersApi, User as PMOUser } from 'performo-api';
import { Component, Vue, Prop } from 'vue-property-decorator';
import { mapGetters } from 'vuex';

@Component({
  components: {},
  computed: mapGetters({
    currentUser: 'currentUser',
    currentPmoUser: 'performoUser',
    usersApi: 'usersApi'
  })
})
export default class InOutChanger extends Vue {
  private currentUser!: User;

  @Prop({ required: false, default: 'My Status' })
  private labelOverride?: string;

  private usersApi!: UsersApi;
  private currentPmoUser!: PMOUser;

  get vbtnSelected() {
    if (this.currentPmoUser.inOutStatus === 'In') return 0;
    else return 1;
  }

  get getInOutStatusTitle() {
    return `Marked ${this.currentPmoUser.inOutStatus} ${
      this.currentPmoUser.inOutDateTime
        ? 'on ' + this.currentPmoUser.inOutDateTime
        : ''
    }`;
  }

  private changeStatus(status: string) {
    this.usersApi
      .changeStatus({
        changeInOutStatusCommand: {
          userId: parseInt(this.currentUser.profile.sub),
          newStatus: status
        }
      })
      .then((u) => this.$store.commit('setPerformoUser', u))
      .finally();
  }
}
